import { createAsyncThunk } from "@reduxjs/toolkit";

import { gethomePageRevisions } from "@/models";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

export const fetchHomePageRevision = createAsyncThunk(
  "homePageRevision/fetchHomePageRevision",
  async (params: Partial<{ config: any }>, { getState, rejectWithValue }) => {
    try {
      const { config } = params;
      const { adapter } = getState() as AppState;
      const { baseUrl } = adapter.adapter;
      const { token } = fetchAuthToken(getState());

      const response = await gethomePageRevisions(
        token,
        baseUrl,
        {
          page: 1,
          per_page: 1,
          filters: { sort: { id: "desc" }, published: true }
        },
        config
      );

      return response.length ? response[0] : response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
